import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dormancy-message',
    templateUrl: './dormancy-message.component.html',
    styleUrls: ['./dormancy-message.component.scss'],
    standalone: false
})
export class DormancyMessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
